
// 资源上传模块请求
import request from '@/utils/request.js'

// 删除文件上传的文件
export const deleteFile =(filePath,userName)=>{
    return request.get(
        '/file/deleteFile',
        {
            params:{
                filePath:filePath,
                userName:userName
            }
        }
    )
}

// 资源上传提交
export const resourceAdd=async (resourceData)=>{
    const res= await request.post(
        '/file/resourceAdd',
        resourceData
    );
    return res;
}

// 上传资源查询页面
export const queryResource=(queryData)=>{
    return request.post(
        '/file/queryResource',
        queryData
    )
}

// 判断当前资源是否需要积分
export const contentWhetherNeedPrice=(needPrice)=>{
    return request.post(
        '/file/contentWhetherNeedPrice',
        needPrice
    )
}

// 判断用户的积分是否充足
export const priceAmple=(ampleData)=>{
    return request.post(
        '/file/priceAmple',
        ampleData
    )
}

// 积分充足，更改数据信息
export const updatePriceAmple=(ampleData)=>{
    return request.post(
        '/file/updatePriceAmple',
        ampleData
    )
}


// 查询上传资源详情，通过resourceId
export const findResDetailsByResId=(resourceId)=>{
    return request.get(
        '/file/findResourceDetailsByResId',
        {
            params: {  
                resourceId: resourceId,  
              }
        }
    )
}


// 通过resourceId获取fileUrl，进行下载方法
export const getReqFileUrl =(resourceId)=>{
    return request.get(
        '/file/getReqFileUrl',
        {
            params:{
                resourceId:resourceId
            }
        }
    )

}

// 我的-删除当前记录数据方法请求
export const delResource=(resourceId)=>{
    return request.get(
        '/file/delResource',
        {
            params:{
                resourceId:resourceId
            }
        }
    )
}
